import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=639adc3f&scoped=true&"
import script from "./Security.vue?vue&type=script&lang=js&"
export * from "./Security.vue?vue&type=script&lang=js&"
import style0 from "./Security.vue?vue&type=style&index=0&id=639adc3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639adc3f",
  null
  
)

export default component.exports